import { createContext, useContext, type ReactNode } from "react";
import { DEFAULT_ROLE_LABELS, type RoleLabels } from "@calega/versioning";

const RoleLabelsContext = createContext<RoleLabels>(DEFAULT_ROLE_LABELS);

export function RoleLabelsProvider({ labels, children }: { labels?: RoleLabels; children: ReactNode }) {
  return <RoleLabelsContext.Provider value={labels ?? DEFAULT_ROLE_LABELS}>{children}</RoleLabelsContext.Provider>;
}

export const useRoleLabels = () => useContext(RoleLabelsContext);
